module.exports = __webpack_public_path__ + "img/jaguar.de18e1d7.png";